module.exports = __webpack_public_path__ + "static/media/Floorplan.31dad560.jpg";